<template>
    <div class="without-review-container">
        <!-- 标题 -->
        <div class="title">免申即享数据同步平台</div>
        <el-card class="card-section">
            <div class="section-header">
                <span class="section-title">信息同步</span>
            </div>
            <div class="upload-tip-row-v3" v-if="auth[0]">
                <!-- 左侧上传区 -->
                <div class="upload-area-v3">
                    <el-upload class="upload-demo" drag :action="uploadUrl" :file-list="fileList" :headers="headers"
                        :before-upload="beforeUpload" :on-success="handleUploadSuccess" :on-error="handleUploadError"
                        :on-remove="handleRemove" multiple accept=".xls,.xlsx" :auto-upload="false" ref="uploadRef"
                        :on-change="handleChange" :data="{
                            userName: this.userName,
                            fileName: this.fileList.length > 0 ? this.fileList[0].name : ''
                        }">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传Excel文件（.xls/.xlsx），且不超过5MB</div>
                    </el-upload>
                </div>
                <!-- 右侧温馨提示 -->
                <div class="tip-area-v3">
                    <div class="tip-title">
                        <i class="el-icon-info"></i>
                        <span>温馨提示：</span>
                    </div>
                    <ul class="tip-list-v2">
                        <li>1. 请严格按照模板格式填写数据</li>
                        <li>2. 数据量较大时，处理的时间可能较长，请耐心等待</li>
                        <li>3. 上传成功后，结果可在列表中导出</li>
                    </ul>
                </div>
            </div>
            <div v-else class="progress-container">
                <div class="progress-left">
                    <p>本月进度</p>
                    <div v-for="item in schedule" :key="item.batchId">
                        {{ item.trueName }}：
                        <el-progress :percentage="progressBarStyle(item.status)" />
                    </div>
                </div>
                <!-- <div class="progress-right">
                    <el-button type="primary" size="small" @click="downloadEndResult">下载最终比对结果</el-button>
                </div> -->
            </div>
            <!-- 中间按钮区 -->
            <div class="upload-btn-area-v3" v-if="auth[1] === 1">
                <el-button type="primary" size="default" @click="downloadTemplate">下载模板</el-button>
                <el-button type="primary" size="default" @click="submitUpload">开始上传</el-button>
            </div>
            <div class="upload-btn-area-v3" v-if="auth[1] === 0">
                <el-button type="primary" size="default" @click="downloadProcess">下载待校验数据</el-button>
                <el-button type="primary" size="default" @click="submitUpload">开始上传</el-button>
            </div>
        </el-card>

        <!-- 结果表格 -->
        <el-card class="card-section">
            <div class="section-header">
                <span class="section-title">上传记录</span>
            </div>
            <div class="header-buttons" v-if="auth[2] === 1" style="margin-top: 20px;">
                <el-radio-group v-model="selectedDept" size="small" @change="fetchUploadRecords">
                    <el-radio-button v-for="item in schedule" :key="item.batchId" :label="item.userId" border>
                        {{ item.trueName }}
                    </el-radio-button>
                </el-radio-group>
            </div>

            <el-table :data="tableData" style="margin-top: 20px;" border stripe>
                <el-table-column prop="id" label="ID" align="center"></el-table-column>
                <el-table-column prop="batchId" label="批次号" align="center"></el-table-column>
                <el-table-column prop="total" label="总数量" align="center"></el-table-column>
                <el-table-column prop="success" label="有效数据" align="center"></el-table-column>
                <el-table-column label="提交时间" align="center">
                    <template slot-scope="scope">
                        {{ formatDate(scope.row.createTime) }}
                    </template>
                </el-table-column>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope">
                        {{ mapStatus(scope.row.status) }}
                    </template>
                </el-table-column>
                <el-table-column label="下载记录" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="downloadFile('下载记录', scope.row)">下载</el-button>
                    </template>
                </el-table-column>

            </el-table>

            <div class="pagination-container">
                <el-pagination :page-size="pagination.pageSize" :current-page="pagination.pageNum"
                    :total="pagination.total" layout="total, prev, pager, next, jumper"
                    @current-change="handlePageChange" />
            </div>
        </el-card>
    </div>
</template>

<script>
import axios from "axios";
import Global from '@/utils/global';
import Cookies from "js-cookie";
export default {
    name: "withoutReview",
    data() {
        return {
            uploadUrl: `${Global.baseUrl}/instant/upload`,
            headers: {
                token: Cookies.get("token")
            },
            progress: 0,
            fileList: [],
            tableData: [],
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            selectedDept: '',
            userName: sessionStorage.getItem('user'),
            userId: sessionStorage.getItem('deptId'),
            auth: [],
            schedule: []
        };
    },
    created() {
        this.fetchAuth();
        this.fetchUploadRecords();
        this.fetchProgress();
    },
    methods: {
        formatDate(dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        mapStatus(status) {
            switch (status) {
                case 0:
                    return '失败';
                case 1:
                    return '成功';
                case 2:
                    return '上传中';
                case 3:
                    return '比对中';
                default:
                    return '未知状态';
            }
        },
        async fetchUploadRecords() {
            let name = this.userName;
            if (this.auth[2] === 1) {   //人社/卫健/公安查自己的记录，民政没用上传记录，参数为列表框选的值
                name = this.selectedDept;
            }
            try {
                const response = await axios.get(`${Global.baseUrl}/instant/history`, {
                    headers: this.headers,
                    params: {
                        userName: name,
                        pageNum: this.pagination.pageNum,
                    }
                });
                if (response.data.code === 200) {
                    this.tableData = response.data.data.content;
                    this.pagination.pageNum = response.data.data.pageNum;
                    this.pagination.pageSize = response.data.data.pageSize;
                    this.pagination.total = response.data.data.totalSize;
                } else {
                    this.$message.error(response.data.message || '获取上传记录失败');
                }
            } catch (error) {
                console.error('获取上传记录失败:', error);
                this.$message.error('获取上传记录失败，请稍后重试');
            }
        },
        async fetchProgress() {
            try {
                const response = await axios.get(`${Global.baseUrl}/instant/progress`, {
                    headers: this.headers,
                    params: {
                        userName: this.userName
                    }
                });
                if (response.data.code === 200) {
                    this.schedule = response.data.data;
                } else {
                    this.$message.error(response.data.message || '获取进度失败');
                }
            } catch (error) {
                console.error('获取进度失败:', error);
                this.$message.error('获取进度失败，请稍后重试');
            }

        },
        async fetchAuth() {
            try {
                const response = await axios.get(`${Global.baseUrl}/instant/getUserAuthority`, {
                    headers: this.headers,
                    params: {
                        userId: this.userId
                    }
                });
                if (response.data.code === 200) {
                    this.auth = response.data.data;
                    if (this.auth[2] === 1) { // 上传权限
                        this.uploadUrl = `${Global.baseUrl}/instant/upload`;
                    }
                }
            }
            catch (error) {
                console.error('获取权限失败:', error);
                this.$message.error('获取权限失败，请稍后重试');
            }
        },
        progressBarStyle(status) {
            let percentage = 0;
            switch (status) {
                case 0:
                    percentage = 0;
                    break;
                case 1:
                    percentage = 100;
                    break;
                case 2:
                    percentage = 50;
                    break;
                case 3:
                    percentage = 50;
                    break;
                default:
                    percentage = 0;
            }
            return percentage;
        },
        async downloadTemplate() {
            try {
                const response = await axios.get(`${Global.baseUrl}/instant/download/template`, {
                    headers: this.headers,
                    responseType: 'blob'
                });
                if (response.status === 200) {
                    const contentDisposition = response.headers['content-disposition'];
                    const fileNameMatch = contentDisposition && contentDisposition.match(/filename=(.*)/);
                    const fileName = fileNameMatch ? decodeURIComponent(fileNameMatch[1].replace(/"/g, '')) : 'template.xlsx';
                    const blob = new Blob([response.data], { type: response.data.type });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                    this.$message.success('模板下载成功');
                }
            } catch (error) {
                console.error('下载模板失败:', error);
                this.$message.error('模板下载失败，请稍后重试');
            }
        },
        async downloadProcess() {
            try {
                const response = await axios.get(`${Global.baseUrl}/instant/download/processed`, {
                    headers: this.headers,
                    params: {
                        userName: this.userName
                    },
                    responseType: 'blob'
                });

                // 先尝试解析响应为 JSON，检查是否为错误信息 
                const reader = new FileReader();
                reader.readAsText(response.data);
                await new Promise((resolve, reject) => {
                    reader.onload = () => {
                        try {
                            const jsonData = JSON.parse(reader.result);
                            if (jsonData && jsonData.code && jsonData.code !== 200) {
                                console.log(jsonData);
                                this.$message.error(jsonData.message || '下载失败');
                                return resolve();
                            }
                        } catch (e) {
                            // 解析失败，说明是文件流，正常下载 
                        }

                        if (response.status === 200) {
                            const contentDisposition = response.headers['content-disposition'];
                            const fileNameMatch = contentDisposition && contentDisposition.match(/filename=(.*)/);
                            const fileName = fileNameMatch ? decodeURIComponent(fileNameMatch[1].replace(/"/g, '')) : '待比对数据.xlsx';
                            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', fileName);
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(url);
                            this.$message.success('下载成功');
                        }
                        resolve();
                    };
                    reader.onerror = () => {
                        this.$message.error('下载失败');
                        reject();
                    };
                });
            } catch (error) {
                this.$message.error('下载失败');
            }
        },
        handleUploadSuccess(response) {
            console.log(response);
            if (response && response.code && response.code !== 200) {
                // 业务处理失败，给出错误提示
                this.$message.error(response.message || '文件上传失败');
                this.fetchUploadRecords();
                return;
            }
            this.$message.success("上传成功！");
            this.fetchUploadRecords();
        },
        handleUploadError(err, file, fileList) {
            this.$message.error("上传失败！");
        },
        handleRemove(file, fileList) {
            this.fileList = fileList;
        },
        reUpload() {
            this.progress = 0;
            this.fileList = [];
        },
        downloadFile(type, row) {
            let userName = this.userName;
            if (this.auth[2] === 1) {
                userName = this.selectedDept;
            }
            axios.get(`${Global.baseUrl}/instant/download`, {
                headers: this.headers,
                params: {
                    userName: userName,
                    batchId: row.batchId
                },
                responseType: 'blob'
            }).then(response => {
                // 先尝试解析响应为 JSON，检查是否为错误信息 
                const reader = new FileReader();
                reader.readAsText(response.data);
                reader.onload = () => {
                    try {
                        const jsonData = JSON.parse(reader.result);
                        if (jsonData && jsonData.code && jsonData.code !== 200) {
                            console.log(jsonData);
                            this.$message.error(jsonData.message || `下载失败`);
                            return;
                        }
                    } catch (e) {
                        // 解析失败，说明是文件流，正常下载 
                    }
                    // 处理文件下载 
                    const contentDisposition = response.headers['content-disposition'];
                    const fileNameMatch = contentDisposition && contentDisposition.match(/filename=(.*)/);
                    const fileName = fileNameMatch ? decodeURIComponent(fileNameMatch[1].replace(/"/g, '')) : `记录_${row.batchId}.xlsx`;
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                    this.$message.success(`下载成功`);
                };
                reader.onerror = () => {
                    console.error(`读取响应失败`);
                    this.$message.error(`下载失败，请稍后重试`);
                };
            }).catch(error => {
                console.error(`下载失败:`, error);
                this.$message.error(`下载失败，请稍后重试`);
            });
        },
        handlePageChange(page) {
            this.pagination.pageNum = page;
            this.fetchUploadRecords();
        },
        beforeUpload(file) {
            const isExcel =
                file.type === 'application/vnd.ms-excel' ||
                file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                /\.xls$|\.xlsx$/i.test(file.name);
            const isLt5M = file.size / 1024 / 1024 < 20;
            if (!isExcel) {
                this.$message.error('只能上传Excel文件（.xls/.xlsx）！');
                return false;
            }
            if (!isLt5M) {
                this.$message.error('文件大小不能超过20MB！');
                return false;
            }
            return true;
        },
        submitUpload() {
            if (this.fileList.length === 0) {
                this.$message.warning('请选择要上传的文件！');
                return;
            }
            this.$refs.uploadRef.submit();
        },
        handleChange(file, fileList) {
            if (fileList.length > 1) {
                fileList.splice(0, fileList.length - 1);
            }
            this.fileList = fileList;
        },
        handleUploadBtnClick() {
            if (this.fileList.length === 0) {
                this.$message.warning('请选择要上传的文件！');
            }
        },
        async downloadEndResult() {
            try {
                const response = await axios.get(`${Global.baseUrl}/instant/download/result`, {
                    headers: this.headers,
                    params: {
                        userName: this.userName
                    },
                    responseType: 'blob'
                });

                // 先尝试解析响应为 JSON，检查是否为错误信息 
                const reader = new FileReader();
                reader.readAsText(response.data);
                await new Promise((resolve, reject) => {
                    reader.onload = () => {
                        try {
                            const jsonData = JSON.parse(reader.result);
                            if (jsonData && jsonData.code && jsonData.code !== 200) {
                                console.log(jsonData);
                                this.$message.error(jsonData.message || '下载最终比对结果失败');
                                return resolve();
                            }
                        } catch (e) {
                            // 解析失败，说明是文件流，正常下载 
                        }

                        if (response.status === 200) {
                            const contentDisposition = response.headers['content-disposition'];
                            const fileNameMatch = contentDisposition && contentDisposition.match(/filename=(.*)/);
                            const fileName = fileNameMatch ? decodeURIComponent(fileNameMatch[1].replace(/"/g, '')) : '最终比对结果.xlsx';
                            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', fileName);
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(url);
                            this.$message.success('最终比对结果下载成功');
                        }
                        resolve();
                    };
                    reader.onerror = () => {
                        console.error('读取响应失败');
                        this.$message.error('下载最终比对结果失败，请稍后重试');
                        reject();
                    };
                });
            } catch (error) {
                console.error('下载最终比对结果失败:', error);
                this.$message.error('下载最终比对结果失败，请稍后重试');
            }
        },
    }
};
</script>

<style scoped>
.without-review-container {
    background: #f4f6fa;
    min-height: 100vh;
    padding: 32px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.title {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 32px;
    text-align: center;
    color: #222;
    letter-spacing: 2px;
}

.card-section {
    width: 80%;
    margin-bottom: 28px;
    border-radius: 12px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.04);
    border: none;
    background: #fff;
}

.step-card {
    padding-bottom: 12px;
}

.section-header {
    margin-bottom: 18px;
    display: flex;
    align-items: center;
}

.section-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    border-left: 4px solid #409EFF;
    padding-left: 12px;
    letter-spacing: 1px;
}

.download-row {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.upload-tip-row-v3 {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 32px;
    margin-top: 8px;
}

.upload-area-v3 {
    flex: 1 1 340px;
    min-width: 320px;
    background: #f7f8fa;
    border-radius: 14px;
    padding: 32px 18px 24px 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 2px 8px 0 rgba(64, 158, 255, 0.04);
}

.upload-dragger {
    width: 320px;
}

.upload-dragger-icon {
    font-size: 48px;
    color: #bfbfbf;
    margin-bottom: 12px;
}

.el-upload__text em {
    color: #409EFF;
    font-style: normal;
    font-weight: 500;
}

.el-upload__tip {
    color: #999;
    font-size: 13px;
    margin-top: 8px;
}

.tip-area-v3 {
    flex: 1 1 340px;
    min-width: 320px;
    background: #f7f8fa;
    border-radius: 14px;
    padding: 32px 24px 24px 24px;
    box-shadow: 0 2px 8px 0 rgba(64, 158, 255, 0.04);
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.tip-title {
    font-size: 16px;
    font-weight: 600;
    color: #888;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
}

.tip-title .el-icon-info {
    color: #409EFF;
    font-size: 20px;
    margin-right: 6px;
}

.tip-list-v2 {
    margin: 0 0 0 20px;
    padding: 0;
    list-style: none;
}

.tip-list-v2 li {
    color: #666;
    font-size: 15px;
    font-weight: 500;
    margin: 4px 0;
    line-height: 1.7;
}

.uploaded-info {
    display: flex;
    align-items: center;
    color: #67c23a;
    font-size: 16px;
}

.pagination-container {
    margin-top: 16px;
    display: flex;
    align-items: center;
}

.page-info {
    margin-left: 24px;
    color: #13ce66;
    font-size: 15px;
}

.steps-title {
    font-size: 20px;
    font-weight: 600;
    color: #222;
    margin-bottom: 18px;
    text-align: center;
    letter-spacing: 1px;
}

.custom-steps {
    margin-bottom: 0;
    padding-bottom: 8px;
}

.custom-step-icon {
    font-size: 32px;
    color: #409EFF;
    background: #eaf3ff;
    border-radius: 50%;
    padding: 8px;
}

.step-main-title {
    font-size: 16px;
    font-weight: 600;
    color: #409EFF;
}

.step-sub-title {
    font-size: 12px;
    color: #888;
    margin-top: 2px;
}

.el-steps--horizontal .el-step__icon.is-icon {
    background: transparent;
    border: none;
}

.el-step__title.is-process {
    color: #409EFF !important;
}

.el-step__title.is-finish {
    color: #67c23a !important;
}

.section-tip {
    margin-left: 18px;
    color: #409EFF;
    font-size: 14px;
    background: #f0f7ff;
    padding: 4px 14px;
    border-radius: 12px;
    display: inline-block;
}

.custom-warn-alert {
    flex: 1 1 380px;
    min-width: 320px;
    margin-top: 0;
    margin-left: 0;
    background: #fafbfc !important;
    border: none !important;
    color: #666;
    font-size: 15px;
    box-sizing: border-box;
}

.warn-list {
    margin: 0 0 0 24px;
    padding: 0;
    list-style: none;
}

.warn-list li {
    margin: 2px 0;
    color: #666;
    font-size: 15px;
    font-weight: 500;
}

.warn-red {
    color: #666;
}

.upload-btn-area-v3 {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 220px;
    min-height: 180px;
}

.start-upload-btn {
    width: 180px;
    height: 80px;
    font-size: 22px;
    font-weight: 600;
    border-radius: 18px;
    box-shadow: 0 4px 16px 0 rgba(64, 158, 255, 0.10);
    background: linear-gradient(90deg, #6ec6ff 0%, #409EFF 100%);
    border: none;
    transition: box-shadow 0.2s, transform 0.2s;
}

.start-upload-btn:hover {
    box-shadow: 0 8px 24px 0 rgba(64, 158, 255, 0.18);
    transform: translateY(-2px) scale(1.04);
}

.progress-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 10px 0;
}

.progress-left {
    flex: 1;
}

.progress-right {
    min-width: 100px;
}

.progress-left p {
    margin-bottom: 10px;
    font-weight: 500;
}

.el-progress {
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Myvue/withoutReview.vue